<template>
    <div class="page-wrap">
        <TopOperateBar @updateQueryData="queryHandler" />
        <div class="page-table">
            <Table class="table-list" :config="tableConfig" :dataset="tableData" @columnClick="tableColumnClick" />
            <BottomOperateBar
                :total="totals"
                :allCheck="allCheckFlag"
                @allCheckChange="allCheckHandle"
                @linkedClick="linkedHandle"
                @deleteClick="deleteHandle"
            />
        </div>
        <PageControl
            v-show="totals >= 10"
            class="page-control"
            :total="totals"
            :curPage="curPage"
            :pageLength="curPageLen"
            @pageChange="pageChange"
        />
    </div>
</template>

<script>
import TopOperateBar from "./TopOperateBar";
import Table from "@/views/zhiji/bComponents/table/Table";
import BottomOperateBar from "./BottomOperateBar";
import PageControl from "@/views/zhiji/bComponents/pageController/PageControl";
import { conventionalTableConfig } from "../../clusterPageConfig.js";

import i18n from "@/i18n";

export default {
    name: "ConventionalData",
    components: {
        TopOperateBar,
        Table,
        PageControl,
        BottomOperateBar
    },
    data() {
        return {
            curPage: 1,
            curPageLen: 10,
            startTime: this.zhiji.dateFormat(new Date(), "YYYY-MM-DD 00:00"),
            endTime: this.zhiji.dateFormat(new Date()),
            searchType: "all",
            checkedArr: []
        };
    },
    computed: {
        tableConfig() {
            return conventionalTableConfig();
        },
        tableData() {
            return this.convertListData(this.getStorePorp("conventionalData").tableData);
        },
        totals() {
            return this.getStorePorp("conventionalData").totals;
        },
        allCheckFlag() {
            return this.checkedArr.length !== 0 && this.tableData.length == this.checkedArr.length;
        }
    },
    watch: {
        tableConfig() {
            this.getConventionalData();
        }
    },
    mounted() {
        this.getConventionalData();
    },
    methods: {
        getConventionalData() {
            this.$store.dispatch("zhiji/queryConventionalList", {
                startTime: this.startTime,
                endTime: this.endTime,
                size: this.curPageLen,
                page: this.curPage,
                channel: "",
                field: "",
                lang: ""
            });
        },
        getStorePorp(propName) {
            return this.$store.state.zhiji.questionCluster[propName];
        },
        queryHandler(data) {
            this.curPage = 1;
            this.removeAllCheck();
            this.$store.dispatch("zhiji/queryConventionalList", {
                startTime: data.startDate,
                endTime: data.endDate,
                channel: data.channel,
                search: data.keyWord,
                page: this.curPage,
                lang: data.lang
            });
        },
        tableColumnClick(data) {
            if (data.type == "Checkbox") {
                this.tableColumnCheck(data);
            }
        },
        tableColumnCheck(data) {
            if (data.checked) {
                this.checkedArr.indexOf(data.rowData.rowId) === -1 && this.checkedArr.push(data.rowData.rowId);
            } else {
                let itemcheckedIdx = this.checkedArr.indexOf(data.rowData.rowId);
                itemcheckedIdx !== -1 && this.checkedArr.splice(itemcheckedIdx, 1);
            }
        },
        pageChange(data) {
            if (this.curPageLen == data.pageLength && this.curPage == data.curPage) {
                return;
            }
            this.curPageLen = data.pageLength;
            this.curPage = data.curPage;
            this.$store.dispatch("zhiji/queryConventionalList", {
                page: data.curPage,
                size: data.pageLength
            });
            this.removeAllCheck();
        },
        allCheckHandle(data) {
            data.checked ? this.addAllCheck() : this.removeAllCheck();
        },
        addAllCheck() {
            this.checkedArr.push(...this.tableData.map(row => row.rowId));
        },
        removeAllCheck() {
            this.checkedArr.splice(0);
        },
        linkedHandle() {
            if (!this.isCheckedData()) {
                return;
            }
            let checkedQuestion = [];
            this.tableData.forEach(function(item) {
                if (item.check) {
                    checkedQuestion.push({
                        questionId: item.rowId,
                        questionText: item.question
                    });
                }
            });
            this.$store.dispatch("zhiji/showModal", {
                type: "LinkedQuestionModal",
                data: {
                    question: checkedQuestion,
                    title: i18n.t("zhiji.cluster.closeLoop.linkSimilar"),
                    confirm: data => {
                        this.saveLinkedQuestion(data);
                        this.removeAllCheck();
                    }
                }
            });
        },
        saveLinkedQuestion(data) {
            this.zhiji
                .requestByServiceName("linkedConventional", {
                    questions: data.questionArray,
                    questionIds: data.questionIdArray,
                    linkQuestionId: data.linkQuestionId
                })
                .then(resp => {
                    if (resp.errCode) {
                        this.$store.dispatch("zhiji/showModal", {
                            type: "MessageModal",
                            data: {
                                type: "error",
                                message: resp.errMessage
                            }
                        });
                    }
                    this.$store.dispatch("zhiji/queryConventionalList", {});
                });
        },
        deleteHandle() {
            this.isCheckedData() &&
                this.$store.dispatch("zhiji/showModal", {
                    type: "MessageModal",
                    data: {
                        type: "tip",
                        message: i18n.t("zhiji.cluster.deleteConfim") + " " + this.checkedArr.length + " " + i18n.t("zhiji.cluster.deleteQues"),
                        cancel: () => {},
                        confirm: () => {
                            this.zhiji
                                .requestByServiceName("deleteConventional", {
                                    questionIds: JSON.stringify(this.checkedArr)
                                })
                                .then(() => {
                                    this.$store.dispatch("zhiji/queryConventionalList", {});
                                    this.removeAllCheck();
                                });
                        }
                    }
                });
        },
        isCheckedData() {
            if (this.checkedArr.length < 1) {
                this.$store.dispatch("zhiji/showModal", {
                    type: "MessageModal",
                    data: {
                        type: "tip",
                        message: i18n.t("zhiji.cluster.selectedTip")
                    }
                });
                return false;
            }
            return true;
        },
        convertListData(data) {
            return data.map(item => {
                return {
                    ...item,
                    check: this.getCheckState(item.rowId)
                };
            });
        },
        getCheckState(id) {
            return this.checkedArr.some(itemId => itemId === id);
        }
    }
};
</script>

<style scoped lang="scss">
.page-wrap {
    height: 100%;
    display: flex;
    flex-direction: column;
    .page-table {
        flex: 1;
        background: #fafbfd;
        padding: 16px 16px 0 16px;
        border: 1px solid #d9e4ef;
        .table-list {
            background: #fff;
            border-width: 0 1px 1px 1px;
            border-style: solid;
            border-color: #e3ecf5;
        }
    }
    .page-control {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px 0;
        text-align: center;
        color: rgba(65, 71, 94, 0.7);
    }
}
</style>
